<template>
  <div style="background-color: #fff;">
    <AchievementsHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjcg-yzxm.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" :child="'achievements'" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            优质项目
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <div class="recruitmentSmallBox">
            <div class="recruitmentSmallInfo" v-for="(item, index) in dataSource" :key="index" @click="goDetail(item.id)">
              <div class="recruitmentBottomBox">
                <div class="recruitmentBottomTopBox">
                  <img v-if="item.picture" :src="getImg(item.picture)" alt="">
                  <img v-else src="@/assets/img/defaultImg.png" alt="">
                </div>
                <div class="recruitmentBottomMiddleBox">{{ item.projectName }}
                  <div class="recruitmentBottomRightBottom"></div>
                </div>
                <div class="recruitmentBottomBottomBox">{{ item.projectView }}</div>
                <div class="recruitmentBottomBottomBottomBox">
                  <p>技术领域：
                    <dict-render :dict-obj="dictObjs['research_field']" v-if="item.researchField"
                      :text="item.researchField"></dict-render>
                  </p>
                  <p>负责人：{{ item.projectLinkman }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { getDistMixin, listMixin, dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import FilterInfo from '@/components/other/FilterInfo';
import { achievementFontInfo } from "@/api/achievementsService";
import { file_service } from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin, dictMixin],
  components: { AchievementsHeader, FilterInfo, DictRender, LayoutFooter },
  data() {
    return {
      dictNames: 'research_field',
      title: '',
      queryParam: { professionalTitle: '' },
      listUrl: achievementFontInfo.projectPageList,
      current: 1,
      pageSize: 12,
    }
  },
  created() {
    this.getDist('research_field')
    this.getDist('project_demand')
    this.title = this.$route.query.type
  },
  mounted() {
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['技术领域'] = this.industryArr
      obj['search'] = 'researchField'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)


      let type = {}
      let type1 = {}
      let type2 = {}
      let type3 = {}
      type1['项目需求'] = this.projectDemandArr
      type['search'] = 'projectDemand'
      type2['arr'] = type1
      type3 = Object.assign(type, type2)
      list.push(type3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(id) {
      this.$router.push({
        path: '/achievements/components/corpProjectDetail',
        query: { type: '优质项目', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;
      min-height: 300px;

      .recruitmentSmallBox {
        padding: 12px 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .recruitmentSmallInfo {
          width: 23%;
          border: 1px solid #dedede;
          cursor: pointer;
          margin: 0 12px 15px 12px;

          .recruitmentBottomBox {
            overflow: hidden;
            padding: 10px 12px 0 12px;
            width: 100%;
            color: #333;
            font-size: 14px;
            text-align: center;

            .recruitmentBottomTopBox {
              width: 88px;
              height: 88px;
              margin: 10px auto;
              border: 1px solid #dedede;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .recruitmentBottomMiddleBox {
              padding: 12px 0;
              font-size: 16px;
              font-weight: bold;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
            }

            .recruitmentBottomBottomBox {
              color: #666;
              overflow: hidden;
              min-height: 42px;
              margin: 10px 0;
              text-align: left;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .recruitmentBottomBottomBottomBox {
              padding: 8px 0;
              color: #999;
              text-align: left;

              p {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              }
            }
          }
        }

        .recruitmentSmallInfo:hover {
          border: none;
          -webkit-transition: all 0.3s ease 0s;
          transition: all 0.3s ease 0s;
          //border: 1px solid #ffffff;
          cursor: pointer;
          -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
          box-shadow: 0 5px 10px 1px #d2e6ff;
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>